import React, {useState, useEffect, useRef} from 'react';
import ProtectedRoute from '../../routes/protected';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import performanceService from '../../services/data/performance.service';
import moment from "moment";
import 'moment/locale/pt-br'
import { Toast } from 'primereact/toast';
import SkeletonTeam from './skeletonTeam';
import { useFormik } from 'formik';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'


export default function PerformanceReviewList() {

    const cardStyles = {
        transition: 'all 0.3s ease',
    };

    const cardHoverStyles = {
        transform: 'translateY(-5px)',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
        borderColor: '#007bff'
    };

    const [pageLoad, setPageLoad] = useState(true)
    const [filterLoad, setFilterLoad] = useState(false)
    const toast = useRef(null);
    const [itemsList, setItemsList] = useState([]);
    const [page, setPage] = useState(1)
    const [clear, setClear] = useState(false)
    const [_selected] = useState('')

    const canvaRef = useRef()

    const _hideOffCanvas = () => {
        const elem = canvaRef.current
        const modal = bootstrap.Offcanvas.getInstance(elem)
        modal.hide()
    }

    useEffect(() => {
        listItems()
    }, [page])

    function listItems() {
        let data = {
            company_id: localStorage.getItem("companyId"),
        }

        performanceService.listPerformanceReviewOnly(page, data).then((response) => {
            if (response.count > 0){
                setItemsList(response)
            } else {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: "Nenhum item encontrado", life: 4000 });
            }
        }).catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 });
        }).finally(() => {
            setPageLoad(false)
        })
    }

    function addPage() {
        setPage(page + 1)
    }

    function subPage() {
        setPage(page - 1)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: '',
            manager_name: '',
            start_date: '',
            end_date: ''
        },
        onSubmit: values => {

            setFilterLoad(true)
            setClear(true)

            let data = {
                company_id: localStorage.getItem("companyId"),
            }
            if (values.title) {
                data.title = values.title
            }
            if (values.manager_name) {
                data.manager_name = values.manager_name
            }
            if (values.start_date) {
                data.start_date = values.start_date
            }
            if (values.end_date) {
                data.end_date = values.end_date
            }

            performanceService.listPerformanceReviewOnly(1, data).then((response) => {    
                if (response.count > 0){
                    setItemsList(response)
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Ops', detail: "Nenhum item encontrado", life: 4000 });
                }
            }).catch((error) => {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 });
            }).finally(() => {
                setFilterLoad(false)
            })
        }
    })


    return (
        <ProtectedRoute>
            
            <Toast ref={toast} position="top-right" />

            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <div className='col text-bg-green p-3'>
                        <a href='/painel/' className="fs-6 fw-bold ps-5 text-decoration-none text-white">
                            <FontAwesomeIcon className='' icon={solid('arrow-left')} /> Performance
                        </a>
                    </div>
                </div>
                <div className='my-4 mx-5 py-3 rounded-top' style={{minHeight: '500px'}}>

                    {
                        pageLoad ?
                        <SkeletonTeam />
                        :
                        <>
                        <ul className='nav nav-tabs px-3'>                            
                            <li className='nav-item'>
                                <a href='/my/team/performance/' className='nav-link text-green'>
                                    Minha Equipe
                                </a>
                            </li>
                            <li className='nav-item'>
                                <a href='/my/team/performance/matrix/' className='nav-link text-green'>
                                    Matriz
                                </a>
                            </li>
                            <li className='nav-item'>
                                <a href='/performance-template/list/' className='nav-link text-green'>
                                Ciclos de Avaliações
                                </a>
                            </li>
                            <li className='nav-item'>
                                <span className='nav-link active'>
                                    Lista de Avaliações
                                </span>
                            </li>
                        </ul>
                        <div className='bg-white py-4 px-3 rounded'>
                            <div className='row'>
                                <div className='col-3'>
                                    <p className='fw-bold mt-3'>Filtros</p>
                                    <form onSubmit={formik.handleSubmit} className='bg-light p-3 rounded'>
                                        <div className="col mb-3">
                                            <label className="form-label">Título</label>
                                            <input name='title' type="text" className="form-control" {...formik.getFieldProps('title')} />
                                        </div>
                                        <div className='col mb-3'>
                                            <label className="form-label">Nome do Gestor</label>
                                            <input name='manager_name' type="text" className="form-control" {...formik.getFieldProps('manager_name')} />
                                        </div>
                                        <div className='col mb-3'>
                                            <label className="form-label">De</label>
                                            <input className="form-control" name='start_date' type="date" autoComplete="off" {...formik.getFieldProps('start_date')} />
                                        </div>
                                        <div className='col mb-3'>
                                            <label className="form-label">Até</label>
                                            <input className="form-control" name='end_date' type="date" autoComplete="off" {...formik.getFieldProps('end_date')} />
                                        </div>
                                        <div className="btnMargin">
                                            <button className="btn btn-success btn-sm btn-rounded px-4" type="submit">
                                                Filtrar
                                            </button>
                                            {
                                                clear ?
                                                <span role='button' className='fw-bold float-end mt-2' onClick={() => {formik.resetForm(); listItems()}}>Limpar</span>
                                                :null
                                            }
                                            
                                        </div>
                                    </form>
                                </div>
                                <div className='col-9'>
                                    {
                                        filterLoad ?
                                        <SkeletonTeam />
                                        :
                                        <>
                                        {
                                            itemsList && itemsList.results && itemsList.results.length > 0 ?
                                            <>
                                            <div className='row mt-3'>
                                                {
                                                    itemsList.results.map((item, index) =>
                                                        <div key={index} className='col-12 mb-3'>
                                                            <div 
                                                                className='card h-100 shadow-sm border-0'
                                                                style={cardStyles}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.transform = cardHoverStyles.transform;
                                                                    e.currentTarget.style.boxShadow = cardHoverStyles.boxShadow;
                                                                    e.currentTarget.style.borderColor = cardHoverStyles.borderColor;
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.transform = 'none';
                                                                    e.currentTarget.style.boxShadow = '';
                                                                    e.currentTarget.style.borderColor = '';
                                                                }}
                                                            >
                                                                <div className='card-body'>
                                                                    <div className='d-flex justify-content-between align-items-start mb-3'>
                                                                        <div className='dropdown dropend'>
                                                                            <a href='/performance/' onClick={(e) => e.preventDefault()} className='text-decoration-none dropdown-toggle d-inline-flex align-items-center' role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                <span className='card-title h6 mb-0 text-green fw-bold'>
                                                                                    {item.title} - {item.managers?.[0]?.user?.first_name || ''} {item.managers?.[0]?.user?.last_name || ''}
                                                                                </span>
                                                                            </a>
                                                                            <ul className='dropdown-menu border-clean headerBorder font1em mt-1 ms-2'>
                                                                                <li>
                                                                                    <a href={`/performance-review/${item.id}/process/`} target='_blank' className='dropdown-item text-default' rel="noreferrer">
                                                                                        Ver Processo
                                                                                    </a>
                                                                                </li>
                                                                                <li>
                                                                                    <Link 
                                                                                        to={`/performance-review/${item.id}/report/`} 
                                                                                        state={{ item }} 
                                                                                        className='dropdown-item text-default'
                                                                                    >
                                                                                        Ver Relatório
                                                                                    </Link>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                        
                                                                        <span className='badge bg-secondary'>
                                                                            {item.statusDisplay}
                                                                        </span>
                                                                    </div>
                                                                    
                                                                    <div className='row g-2 mb-3'>
                                                                        <div className='col'>
                                                                            <div className='text-center p-2 bg-light rounded'>
                                                                                <div className='fw-bold text-green fs-5'>
                                                                                    {item?.reviewStatus?.total || 0}
                                                                                </div>
                                                                                <small className='text-muted'>Avaliações</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col'>
                                                                            <div className='text-center p-2 bg-light rounded'>
                                                                                <div className='fw-bold text-green fs-5'>
                                                                                    {item?.reviewStatus?.not_started || 0} <small className='text-grey'>({item?.reviewStatus?.not_started_percent || 0}%)</small>
                                                                                </div>
                                                                                <small className='text-muted'>Não Iniciados</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col'>
                                                                            <div className='text-center p-2 bg-light rounded'>
                                                                                <div className='fw-bold text-green fs-5'>
                                                                                    {item?.reviewStatus?.in_process || 0} <small className='text-grey'>({item?.reviewStatus?.in_process_percent || 0}%)</small>
                                                                                </div>
                                                                                <small className='text-muted'>Em Andamento</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col'>
                                                                            <div className='text-center p-2 bg-light rounded'>
                                                                                <div className='fw-bold text-green fs-5'>
                                                                                    {item?.reviewStatus?.completed || 0} <small className='text-grey'>({item?.reviewStatus?.completed_percent || 0}%)</small>
                                                                                </div>
                                                                                <small className='text-muted'>Concluídos</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div className='mb-2'>
                                                                        <small className='text-muted d-block'>
                                                                            <FontAwesomeIcon icon={solid('file-alt')} className='me-1' />
                                                                            {item.assessmentTypeDisplay}
                                                                        </small>
                                                                    </div>
                                                                    
                                                                    <div className='mb-3'>
                                                                        <small className='text-muted d-block'>
                                                                            <FontAwesomeIcon icon={solid('calendar')} className='me-1' />
                                                                            {moment(item.start_date).format("DD-MMM-YYYY")} - {moment(item.end_date).format("DD-MMM-YYYY")}
                                                                        </small>
                                                                    </div>
                                                                   
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className='float-end'>
                                                <nav>
                                                    <ul className='pagination pagination-sm'>
                                                        <li className='page-item'>
                                                            { 
                                                                itemsList.previous ? 
                                                                <span onClick={subPage} role="button" className='page-link text-default'>
                                                                    <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                                                </span>
                                                                :
                                                                <span className='page-link text-grey disabled'>
                                                                    <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                                                </span>
                                                            }
                                                        </li>
                                                        <li className='page-item'>
                                                            {
                                                                itemsList.next ?
                                                                <span onClick={addPage} role="button" className='page-link text-default'>
                                                                    <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                                                </span>
                                                                :
                                                                <span className='page-link text-grey disabled'>
                                                                    <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                                                </span>
                                                            }
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                            </>

                                            :
                                            <>
                                            Nenhum item criado ainda
                                            </>
                                        }
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        </>
                    }
                </div>
            </div>
        </ProtectedRoute>
    )
}